import React from "react";
import { withRouter } from "react-router-dom";
import { Button } from "../ecosystem";
import { translateText } from '../../helpers/data';
import { withTranslation } from 'react-i18next';

const FindCareButton = ({
    fluid,
    icon = "medical",
    label = "Find Care",
    translate,
    t,
    onClick,
}) => {

    return (<>
        <Button
            icon={icon}
            fluid={fluid}
            onClick={onClick}
        >
            {translateText(translate, label, t)}
        </Button>
    </>);
}

export default withRouter(withTranslation()(FindCareButton));